export const routeConfig = {
    characterBetweenRoutes: ' - '
  };
  